// extracted by mini-css-extract-plugin
export var contained = "OneThirdTwoThirdSummaryDisplay-module--contained--3cc4e";
export var summaries = "OneThirdTwoThirdSummaryDisplay-module--summaries--49b3a";